import { addAlumno, dataAlumno, updateAlumnoById } from "data/apiConection.js/dataAlumnos";
import { dataCursosNiveles } from "data/apiConection.js/dataCursos";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";

const FormAlumno = () => {
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    dni: "",
    gender: "",
    birthDate: "",
    address: "",
    phone: "",
    email: "",
    isMinor: false,
    guardianName: "",
    guardianDNI: "",
    guardianPhone: "",
    guardianEmail: "",
    curso_id: "",
  });
  const { id } = useParams();
  const [cursos, setCursos] = useState([]);

  useEffect(() => {
    const fetchAlumno = async () => {
      if (id) {
        const alumno = await getAlumnoById(id);
        if (alumno) {
          setFormData(alumno);
        }
      }
    };

    fetchAlumno();
  }, [id]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const cu = await dataCursosNiveles();
        setCursos(cu);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const getAlumnoById = async (id) => {
    try {
      return await dataAlumno(id, '2025');
    } catch (error) {
      console.error("Error fetching alumno by id:", error.message);
    }
  };

  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;

    if (id === "curso_id") {
      const selectedCurso = cursos.find((curso) => curso.id === parseInt(value));
      setFormData((prevData) => ({
        ...prevData,
        curso_id: value,
        nivel: selectedCurso ? selectedCurso.nivel : "",
        horario: selectedCurso ? selectedCurso.horario : "",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [id]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      const body = {
        ...formData,
        nivel: formData.nivel,
        horario: formData.horario,
      };
      console.log(body);
      if (id) {
        updateAlumnoById(id, body);
      } else {
        addAlumno(body);
      }
    }
    setValidated(true);
  };

  return (
    ( cursos.length>0 && (<Card className="p-4">
      <Card.Body>
        <Card.Title className="mb-4">Formulario de Registro</Card.Title>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="firstName">
              <Form.Label>Nombre/s</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Nombre/s"
                value={formData.firstName}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese su nombre.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="lastName">
              <Form.Label>Apellido/s</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Apellido/s"
                value={formData.lastName}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese su apellido.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="dni">
              <Form.Label>DNI</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="DNI"
                value={formData.dni}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese un DNI válido.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="gender">
              <Form.Label>Sexo</Form.Label>
              <Form.Select
                required
                value={formData.gender}
                onChange={handleInputChange}
              >
                <option value="">Seleccione...</option>
                <option value="male">Masculino</option>
                <option value="female">Femenino</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Por favor, seleccione una opción.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="birthDate">
              <Form.Label>Fecha de nacimiento</Form.Label>
              <Form.Control
                required
                type="date"
                placeholder="Fecha de nacimiento"
                value={formData.birthDate}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese una fecha válida.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="address">
              <Form.Label>Domicilio</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Domicilio"
                value={formData.address}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese su domicilio.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="phone">
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                required
                type="tel"
                placeholder="Teléfono"
                value={formData.phone}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese un número de teléfono válido.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                required
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
              />
              <Form.Control.Feedback type="invalid">
                Por favor, ingrese un email válido.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          {!id && <Form.Group controlId="curso_id">
          <Form.Label>Curso</Form.Label>
              <Form.Select
                value={formData.curso_id}
                onChange={handleInputChange}
              >
                <option value="">Seleccione...</option>
                { (cursos.map( curso => (
                  <option key={curso.id} value={curso.id}>{curso.nivel+' '+curso.horario+' $'+curso.price}</option>
                ))) }
              </Form.Select>
          </Form.Group> }
          
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id="isMinor"
              label="Es menor de edad"
              checked={formData.isMinor}
              onChange={handleInputChange}
            />
          </Form.Group>
          {formData.isMinor && (
            <div className="mt-3">
              <h4>Información del Tutor</h4>
              <Row className="mb-3">
                <Form.Group as={Col} md="6" controlId="guardianName">
                  <Form.Label>Nombre/s y Apellido/s del Tutor</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Nombre/s y Apellido/s del Tutor"
                    value={formData.guardianName}
                    onChange={handleInputChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    Por favor, ingrese el nombre del tutor.
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="guardianDNI">
                  <Form.Label>DNI del Tutor</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="DNI del Tutor"
                    value={formData.guardianDNI}
                    onChange={handleInputChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    Por favor, ingrese un DNI válido del tutor.
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="guardianPhone">
                  <Form.Label>Teléfono del Tutor</Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Teléfono del Tutor"
                    value={formData.guardianPhone}
                    onChange={handleInputChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    Por favor, ingrese un número de teléfono válido del tutor.
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="guardianEmail">
                  <Form.Label>Email del Tutor</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Email del Tutor"
                    value={formData.guardianEmail}
                    onChange={handleInputChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    Por favor, ingrese un email válido del tutor.
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
            </div>
          )}
          <div className="d-grid gap-2 mt-4">
            <Button type="submit" size="lg">
              Enviar Formulario
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>))
    
  );
};

export default FormAlumno;

